export enum StockBalancesTab {
  PICKUP_POINTS = 'pickup_points',
  SUPPLIER_WAREHOUSES = 'supplier_warehouses',
}

export enum StockBalancesFiltersFields {
  SEARCH = 'search',
  SKU = 'sku',
  NAME = 'name',
  EXTERNAL_ID = 'external_id',
  REGION_ID = 'region_id',
  STORE_IDS = 'store_ids',
  PARTNER_IDS = 'partner_ids',
  CATEGORY_IDS = 'category_ids',
  PRICE_MIN = 'price_min',
  DISCOUNT_PRICE_MIN = 'discount_price_min',
}

export type TGetStockBalancesQuery = {
  page?: number;
  limit?: number;
  region_id?: string;
  sku?: string;
  name?: string;
  external_id?: string;
  search?: string;
  active?: boolean;
  available?: boolean;
  quantity_min?: number;
  quantity_max?: number;
  price_min?: number;
  price_max?: number;
  discount_price_min?: number;
  discount_price_max?: number;
  store_ids?: string[];
  partner_ids?: string[];
  category_ids?: string[];
};
